import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import identity from 'lodash/identity';

import Modal from 'react/components/Modal';
import { actionCreators } from 'react/api/actions/chatTicketActions';
import { getResourceTo } from 'react/utils/chatUtils';

const FinishCallModal = ({
  isOpen,
  ticket,
  toggleModal,
  submitFinishCall,
  ticketResolutions,
  userId,
  userName,
  companyId,
  ...others
}) => {
  const ticketResolutionRef = useRef(null);
  const ticketCommentRef = useRef(null);

  function validateFields() {
    const ticketResolutionId = ticketResolutionRef.current.value;

    if (!ticketResolutionId) {
      ticketResolutionRef.current.parentElement.classList.add('has-error');

      return false;
    }

    ticketResolutionRef.current.parentElement.classList.remove('has-error');

    return true;
  }

  function handleSubmit() {
    const ticketResolutionId = ticketResolutionRef.current.value;
    const ticketResolutionComment = ticketCommentRef.current.value;

    const data = {
      userId,
      userName,
      ticketId: ticket.get('ticketId'),
      companyId,
      ticketResolution: {
        id: parseInt(ticketResolutionId, 10)
      },
      ticketResolutionComment,
      ticketTypeId: ticket.get('ticketTypeId')
    };

    validateFields() && submitFinishCall(data);
  }

  const footer = () => (
    <>
      <input
        type="button"
        className="btn closeButton"
        value={getResourceTo('default.button.cancel')}
        onClick={toggleModal}
      />
      <input
        type="button"
        className="btn submitButton"
        value={getResourceTo('Greenmile.Chat.FinishTicketModal.SubmitButton')}
        onClick={handleSubmit}
      />
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      closeModalFn={identity}
      title={getResourceTo('Greenmile.Chat.FinishTicketModal.Title')}
      crossAxisBtn={false}
      className="finishCallModal"
      footer={footer()}
      {...others}
    >
      <div className="text">
        <p>
          {getResourceTo('Greenmile.Chat.FinishTicketModal.Text')}
        </p>
      </div>
      <div className="form">
        <div className="form-block">
          <label htmlFor="call-resolution">
            {getResourceTo('Greenmile.Chat.FinishTicketModal.TicketResolution.Label')}
          </label>
          <select ref={ticketResolutionRef} id="call-resolution">
            {ticketResolutions.map((resolution) => (
              <option
                key={resolution.get('id')}
                value={resolution.get('id')}
              >
                {getResourceTo(resolution.get('description'))}
              </option>
            ))}
          </select>
        </div>
        <div className="form-block">
          <label htmlFor="call-comments">
            {getResourceTo('Greenmile.Chat.FinishTicketModal.TicketComments.Label')}
          </label>
          <textarea ref={ticketCommentRef} id="call-comments" rows="4" />
        </div>
      </div>
    </Modal>
  );
};

FinishCallModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  submitFinishCall: PropTypes.func.isRequired,
  ticketResolutions: PropTypes.object.isRequired,
  ticket: PropTypes.object,
  userId: PropTypes.number,
  userName: PropTypes.string,
  companyId: PropTypes.number
};

FinishCallModal.defaultProps = {
  ticket: {},
  userId: 0,
  userName: '',
  companyId: 0
};

const mapStateToProps = ({ chatTicketActions, configuration }) => ({
  isOpen: chatTicketActions.getIn(['modalFinishCallIsOpen'], false),
  ticketResolutions: chatTicketActions.getIn(['ticketResolutions']),
  ticket: chatTicketActions.getIn(['activeTicket']),
  userId: configuration?.loggedUser?.id,
  userName: configuration?.loggedUser?.name,
  companyId: configuration?.globalConfiguration?.authConfigId
});

const mapDipatchToProps = {
  toggleModal: actionCreators.toggleFinishCallModal,
  submitFinishCall: actionCreators.submitFinishCall
};

export default connect(mapStateToProps, mapDipatchToProps)(FinishCallModal);
